import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Switch from "react-switch";

// css
import styles from "./EditAssignedTherapistModal.scss";
import { Formik, Field } from "formik";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { successMessageToast, userFullName } from "helpers/common";
import { useGetMdtTherapistStatusListQuery } from "store/services/utility";
import { useAssignCheckListMutation } from "store/services/MDT/assessment";
import LoadingIndicator from "components/shared/LoadingIndicator";
import moment from "moment";
import editAssignedTherapistSchema from "./editAssignedTherapist.schema";
import { useUpdateTherapistAssignmentMutation } from "store/services/clientCaseLoads";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";

const EditAssignedTherapistPopup = ({ show, setShow, initialValues, refetch }) => {

    const [updateAssessment, { isLoading: updateAssessmentLoading }] = useUpdateTherapistAssignmentMutation();
    const handlePopup = () => setShow(!show);

    const handleSubmit = async (values) => {
        try {
            let payload = {
                assignmentId: initialValues?.id,
                payload: {
                    assessment_date: values?.assessment_date,
                    meeting_time: values?.meeting_time?.slice(0, 5)
                }
            }
            let { data, error } = await updateAssessment(payload);
            if (error) return;

            successMessageToast(data?.message);
            setShow(false);
            refetch();

        } catch (err) {
            console.error("Error update assessment", err);
        }
    };

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >
                <Formik
                    initialValues={initialValues}
                    validationSchema={editAssignedTherapistSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({
                        handleSubmit,
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                                <Form>
                                    <Row className="">
                                        <Col md="12" className="my-2 my-lg-3">
                                            <div className="d-flex align-items-center justify-content-between pb-2">
                                                <h6
                                                    className="m-0 fw-sbold themeBlue d-flex"
                                                    style={{ fontSize: 14 }}
                                                >
                                                    Assessment Date
                                                    <RequiredFieldAstrick />
                                                </h6>
                                            </div>
                                            <AppDatePicker
                                                name="assessment_date"
                                                className={`${styles.formControl} form-control`}
                                                minDate={moment().add(1, "day").format("YYYY-MM-DD")}
                                            />
                                        </Col>
                                        <Col md="12" className="my-2 my-lg-3">
                                            <div className="d-flex align-items-center justify-content-between pb-2">
                                                <h6
                                                    className="m-0 fw-sbold themeBlue d-flex"
                                                    style={{ fontSize: 14 }}
                                                >
                                                    Meeting Time
                                                    <RequiredFieldAstrick />
                                                </h6>
                                            </div>
                                            <AppInputField
                                                type="time"
                                                name="meeting_time"
                                                placeholder="Enter Request"
                                                className={`${styles.formControl} form-control`}
                                            />
                                        </Col>
                                    </Row>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer className="justify-content-start">
                                <Button
                                    type="submit"
                                    disabled={updateAssessmentLoading}
                                    className="d-flex align-items-center justify-content-center commonBtn"
                                >
                                    {updateAssessmentLoading ? <LoadingIndicator inline/> : "Save"}

                                </Button>
                                <Button
                                    type="button"
                                    className="d-flex align-items-center justify-content-center commonBtn"
                                    onClick={handlePopup}
                                >
                                    Cancel
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
};

export default EditAssignedTherapistPopup;
